var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from '@tanstack/react-query';
import { RoleType } from 'common/types/server-api-dtos';
import { CommonServiceApiTags } from '../api-tags';
import { useNotificationDrawerStore } from 'common/layouts/main-layout/service/notification-drawer-service/service-store/service-store';
import { fetchProfileBalanceAndNotificationsMetaApi } from './api';
import { useBalanceAndNotificationStore } from './service-store/service-store';
import { userService } from 'common/utils/user-service';
import { ONE_MINUTE } from 'common/constants/common-time';
export var useBalanceAndNotificationData = function () {
    var getLastNotificationDate = useNotificationDrawerStore(function (state) { return state.getLastNotificationDate; });
    var setPageContent = useBalanceAndNotificationStore(function (state) { return state.setPageContent; });
    var setInitialized = useBalanceAndNotificationStore(function (state) { return state.setInitialized; });
    var isAuth = userService.isLoggedIn();
    var data = useQuery({
        queryKey: [CommonServiceApiTags.BalanceAndNotifications],
        enabled: isAuth && userService.hasRole(RoleType.Basic),
        refetchInterval: ONE_MINUTE,
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var checkDate, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkDate = getLastNotificationDate();
                        return [4 /*yield*/, fetchProfileBalanceAndNotificationsMetaApi(checkDate)];
                    case 1:
                        data = _a.sent();
                        setInitialized(true);
                        return [2 /*return*/, data];
                }
            });
        }); },
    }).data;
    if (data) {
        setPageContent(data);
    }
};
